export default "__VITE_ASSET__Cds92wPx__"